import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { MenuItem } from './PageTitleBar.tsx';

export interface BreadcrumbProps {
    menuItem: MenuItem;
    parentMenuItem?: MenuItem;
    activeBreadcrumb?: string;
    inactiveBreadcrumb?: string;
    titleSlot?: React.ReactNode;
    t: (key: string) => string;
    style?: React.CSSProperties;
}

const Breadcrumb = ({
    menuItem,
    parentMenuItem,
    activeBreadcrumb,
    inactiveBreadcrumb,
    titleSlot,
    t,
    style
}: BreadcrumbProps) => {
    const breadcrumbText =
        inactiveBreadcrumb || activeBreadcrumb
            ? `${inactiveBreadcrumb || ''}${inactiveBreadcrumb && activeBreadcrumb ? ' / ' : ''}${activeBreadcrumb || ''}`
            : parentMenuItem?.title && menuItem?.title
              ? `${t(parentMenuItem.title)} / ${t(menuItem.title)}`
              : '';

    const displayTitle = parentMenuItem?.title || menuItem.title;

    return (
        <Box className="breadcrumbs" style={style}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                    <Typography variant="h2" className="text-capitalize mb-0" sx={{ whiteSpace: 'nowrap' }}>
                        {titleSlot ? titleSlot : displayTitle ? t(displayTitle) : ''}
                    </Typography>
                    {menuItem.description && (
                        <Tooltip title={t(menuItem.description)} placement="right">
                            <IconButton sx={{ marginLeft: 1, padding: 0.5 }}>
                                <HelpOutline />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>

                {breadcrumbText && <Typography>{breadcrumbText}</Typography>}
            </Box>
        </Box>
    );
};

export default Breadcrumb;
